import type { FunctionComponent } from "react";

import type { EInvoiceAddress } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";

import { joinDefined } from "../eInvoiceFormat.ts";

type Props = { address: EInvoiceAddress };

const EInvoiceAddressBlock: FunctionComponent<Props> = ({ address }) => {
	const { addressLine1, addressLine2, addressLine3, postCode, city, countryCode, countrySubdivision } = address;

	return (
		<div className="break-words">
			{addressLine1 !== null && <span className="block">{addressLine1}</span>}
			{addressLine2 !== null && <span className="block">{addressLine2}</span>}
			{addressLine3 !== null && <span className="block">{addressLine3}</span>}
			{(postCode !== null || city !== null) && <span className="block">{joinDefined([postCode, city], " ")}</span>}
			{(countryCode !== null || countrySubdivision !== null) && (
				<span className="block">{joinDefined([countryCode, countrySubdivision], " ")}</span>
			)}
		</div>
	);
};

export default EInvoiceAddressBlock;
